import { pathOr } from 'ramda';
import { EXTRA_PROMO_TYPES } from '../../constants/promos';
import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';

export function getPromos(state: IApplicationState): IPromo[] {
  const promos: IPromo[] = pathOr([], ['newbuilding', 'promoInfos'], state);

  return promos.filter(promo => !EXTRA_PROMO_TYPES.includes(promo.promoType));
}
